export const URLS = {
  MAIN: {
    site: 'https://designbynidhi.com/',
  },
  HOME: {
    FAVICON: {
      light: 'https://ik.imagekit.io/arsroy5yrc/design-by-nidhi/icons/favicon/chefbook-favicon-light.svg',
      dark: 'https://ik.imagekit.io/arsroy5yrc/design-by-nidhi/icons/favicon/chefbook-favicon-dark.svg',
    },
    PROFILE: {
      src: 'https://res.cloudinary.com/dbgdhzctu/image/upload/v1712429844/design-by-nidhi/home/profile-image.png',
      alt: 'Design by Nidhi - UX/UI Designer Cover Profile Picture',
    },
    RESUME: {
      URL: 'https://dub.sh/2IgZ1Td',
    },
  },
  SOCIAL_LINKS: {
    Dribbble: 'https://dribbble.com/designbynidhi',
    Medium: 'https://medium.com/@designbynidhi',
    Behance: 'https://www.behance.net/design-by-nidhi',
    Youtube: 'https://www.youtube.com/@designbynidhi',
    LinkedIn: 'https://www.linkedin.com/in/design-by-nidhi/',
    Instagram: 'https://www.instagram.com/designbynidhi/',
    Mail: 'mailto:mailto:designbynidhi@gmail.com',
  },
};
